<template>
  <div class="style-tab-content">
    <!-- 样式配置内容区域 -->
    <div class="style-sections">
      <common-style-config :select-item="selectItem" />
    </div>
  </div>
</template>

<script>
import commonStyleConfig from '../styleComp/commonConfig.vue'
export default {
  name: 'styleTab',
  components: { commonStyleConfig },
  props: {
    selectItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
    }
  },
  methods: {
    // 重置样式
    resetStyle() {
      this.$message.success('样式已重置')
    },
  }
}
</script>

<style scoped lang="less">
.style-tab-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .style-sections {
    flex: 1;
    overflow-y: auto;

    .style-section {
      margin-bottom: 24px;
      background: rgba(255, 255, 255, 0.05);
      border-radius: 6px;
      border: 1px solid rgba(255, 255, 255, 0.1);

      .section-header {
        padding: 12px 16px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(255, 255, 255, 0.02);

        h4 {
          margin: 0;
          color: var(--bi-jz-font-color);
          font-size: 14px;
          font-weight: 600;
        }
      }

      .section-content {
        padding: 16px;
        color: var(--bi-jz-font-color);
      }
    }
  }

  .action-buttons {
    padding: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.02);
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    .el-button {
      min-width: 80px;
    }
  }
}
</style>
